export default __webpack_public_path__ + "static/media/sndList.d31ac71c.jpg";